import { EventTicketInfo } from 'core/Components';
import { BASE_URL } from 'core/Utils';
import { DateTime } from 'luxon';
import { ConsumerRedeemableTicket } from 'store/Api';

type MakeTicketInfo = EventTicketInfo & {
  eventTitle: string;
  eventThumbnail?: string;
  eventDateTitle: string;
  cartId?: string;
};

type makeTicketInfo = (
  ticket?: ConsumerRedeemableTicket,
  isAccountPageEnabled?: boolean
) => MakeTicketInfo | null;
export const makeTicketInfo: makeTicketInfo = (ticket, isAccountPageEnabled = false) => {
  if (!ticket) {
    return null;
  }

  const ticketsPath = isAccountPageEnabled ? '/tickets' : '/wallet/tickets';

  // Added ticket_id to ticketShareUrl - safe change
  const ticketShareUrl = `${BASE_URL}${ticketsPath}/${ticket?.uuid}?cart_id=${ticket?.cart_id}&ticket_id=${ticket?.uuid}`;

  // After account page is released, we'll be moving forward with just using the ticket share url as the ticketQrCodeUrl
  // So then, we can find all usages of ticketQrCodeUrl and replace them with ticketShareUrl
  const ticketQrCodeUrl = isAccountPageEnabled
    ? ticketShareUrl
    : `${BASE_URL}/wallet/tickets?ticket_id=${ticket?.uuid}`;

  return {
    eventThumbnail:
      ticket?.store_item?.store_item?.images && ticket?.store_item?.store_item?.images[0]?.url,
    eventTitle: ticket?.store_item?.store_item?.name,
    eventDateTitle: ticket?.event_date?.title,
    title: ticket?.store_item?.store_item?.name,
    eventStartDate: ticket?.event_date?.starting_at,
    venueName: ticket?.store_item?.store_item?.location?.venue_name,
    addressLineOne: ticket?.store_item?.store_item?.location?.address1,
    addressLineTwo: ticket?.store_item?.store_item?.location?.address2,
    city: ticket?.store_item?.store_item?.location?.city,
    state: ticket?.store_item?.store_item?.location?.state,
    zipCode: ticket?.store_item?.store_item?.location?.zip_code,
    ticketId: ticket?.uuid,
    ticketName: ticket?.store_item?.name,
    isExpired: DateTime.now() > DateTime.fromISO(ticket?.expires_at),
    isUsed: !!ticket?.fulfilled_at,
    isDeleted: !!ticket?.deleted_at,
    ticketUrl: ticketShareUrl,
    ticketQrCodeUrl,
    cartId: ticket?.cart_id,
  };
};
